module.exports = __webpack_public_path__ + "121a7f6a670c024243cce9300544e2e6.png";